import { render, staticRenderFns } from "./ActionHeader.vue?vue&type=template&id=4a30b60a&"
import script from "./ActionHeader.vue?vue&type=script&lang=js&"
export * from "./ActionHeader.vue?vue&type=script&lang=js&"
import style0 from "./ActionHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports